import { ClientPortalUser, User } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { setAuthenticatedUserAction, addOrReplaceUserAction, deleteUserAction, setUsersAction } from '../reducers/userReducer';

export const useUserActions = () => {

    const dispatch = useAppDispatch();

    const setAuthenticatedUser = (user: ClientPortalUser | undefined) => {
        dispatch(setAuthenticatedUserAction(user));
    }

    const addOrReplaceUser = (user: User) => {
        dispatch(addOrReplaceUserAction(user));
    }

    const setUsers = (users: User[]) => {
        dispatch(setUsersAction(users));
    }

    const removeUser = (userId: string) => {
        dispatch(deleteUserAction(userId));
    }

    return { setAuthenticatedUser, addOrReplaceUser, setUsers, removeUser };
}
